module.exports = __webpack_public_path__ + "assets/battery_unlock.ee3dcdbf.svg";